var _circle, _ellipse, _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindSpeedBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.06235,
    cy: 7.50766,
    r: 2.88462,
    fill: "#1E2447"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9384,
    cy: 5.55844,
    rx: 2.88461,
    ry: 2.88462,
    transform: "rotate(-1 16.9384 5.55844)",
    fill: "#1E2447"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4945 6.34351L2.7348 8.13676L2.57422 6.99414L15.3339 5.20089L15.4945 6.34351Z",
    fill: "#1E2447"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99991 4.47266C10.8739 4.47266 11.589 5.15279 11.6448 6.01263L11.6483 6.12101V9.41771H8.35156V6.12101L8.35507 6.01263C8.41088 5.15279 9.12597 4.47266 9.99991 4.47266Z",
    fill: "#1E2447"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.17578,
    y: 9.41797,
    width: 1.64835,
    height: 8.24176,
    fill: "#1E2447"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindSpeedBlue);
export default __webpack_public_path__ + "static/media/WindSpeed_Blue.781c44cc.svg";
export { ForwardRef as ReactComponent };